import React from 'react';
import { Image, Button, Carousel } from 'react-bootstrap';
import styles from './IndexPage.module.css';
import logo from './../../assets/images/index_page/splash-logo.png';
import bannerSlide from './../../assets/images/index_page/banner-slide.png';
import publixLogo from './../../assets/images/index_page/publix_logo.png';
import regencyCentersLogo from './../../assets/images/index_page/regency_centers_logo.png';
import kimcoLogo from './../../assets/images/index_page/kimco_logo.png';
import weingartenLogo from './../../assets/images/index_page/weingarten_logo.png';
import verLogo from './../../assets/images/index_page/VER_logo.png';
import testimonialPic from './../../assets/images/index_page/testimonial-photo.png';
import cbreLogo from './../../assets/images/index_page/cbre_logo.png';
import propertySectionBanner from './../../assets/images/index_page/ipad-profile-mockup.png';

const classNames = require('classnames');

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

export const IndexPage = () =>
  <div className='overflow-auto vh-100'>
    <header className='px-3 py-2'>
      <Image src={logo} alt='ID360' />
    </header>
    <section className="container-fluid">
      <div className={styles.bannerSpace}>
        <div className="row">
          <div className='col-md-6'>
            <h6>LEASE SPACES QUICKER</h6>
            <h2>All your retail data in one shareable place.</h2>
            <p>Every ID 360 comes standard with a virtual tour of your space from the floorboards to the rooftop and everything in between. All your data. All in one place. All delivered to your inbox in 10 business days or less. </p>
            <Button className={classNames(styles.btnOutLine, 'rounded-0')} onClick={() => openInNewTab('https://www.idplans.com/the-new-space-profile/')}>LEARN MORE</Button>
          </div>
          <div className='col-md-6 d-flex align-items-center'>
            <Image src={bannerSlide} className='img-fluid' alt='' />
          </div>
        </div>
      </div>
    </section>

    <section className={classNames(styles.sliderCarousel, 'splashPageCarousel')}>
      <div className="container-fluid text-center">
        <div className={styles.headings}>
          <h2>Trusted by the best.</h2>
          <p>We have been providing innovative solutions for the top REITs in the industry for over 20 years.</p>
        </div>
        <div className='my-5'>
          <Image src={publixLogo} alt='' className='mx-4' />
          <Image src={weingartenLogo} alt='' className='mx-4' />
          <Image src={kimcoLogo} alt='' className='mx-4' />
          <Image src={regencyCentersLogo} alt='' className='mx-4' />
          <Image src={verLogo} alt='' className='mx-4' />
        </div>
      </div>

      <Carousel>
        <Carousel.Item className={classNames(styles.carouselItem)}>
          <div className={classNames('container-fluid')}>
            <div className={classNames(styles.carouselContainer, 'd-flex bg-white shadow-sm')}>
              <div className={styles.thumbImg}>
                <Image src={testimonialPic} alt="" />
              </div>
              <div className={classNames(styles.sliderContent, 'text-left p-5')}>
                <div className={styles.customerText}>
                  <Image src={cbreLogo} />
                  <p className={classNames(styles.commetText)}>“ID Plans has always been there for us. This new product is just another example of how they are staying on the cutting edge and challenging the industry.”</p>
                  <h6>John Smith</h6>
                  <p>Property Manager, CBRE</p>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item className={classNames(styles.carouselItem)}>
          <div className={classNames('container-fluid')}>
            <div className={classNames(styles.carouselContainer, 'd-flex bg-white shadow-sm')}>
              <div className={styles.thumbImg}>
                <Image src={testimonialPic} alt="" />
              </div>
              <div className={classNames(styles.sliderContent, 'text-left p-5')}>
                <div className={styles.customerText}>
                  <Image src={cbreLogo} />
                  <p className={classNames(styles.commetText)}>“ID Plans has always been there for us. This new product is just another example of how they are staying on the cutting edge and challenging the industry.”</p>
                  <h6>John Smith</h6>
                  <p>Property Manager, CBRE</p>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </section>


    <section className={styles.propertySection}>
      <div className='container-fluid'>
        <div className="row">
          <div className='col-md-6'>
            <Image src={propertySectionBanner} alt='' className='float-sm-right' />
          </div>
          <div className='col-md-6'>
            <h2>Your One Stop Property Solution.</h2>
            <p>From the pioneers in commercial real estate software, ID 360 is your total solution for showing retail spaces online while minimizing the need for in-person appointments. Right from your desk, offer prospective clients a variety of property views to browse anytime, anywhere. </p>
            <Button className={classNames(styles.btnSignin, 'rounded-0')} onClick={() => openInNewTab('https://www.idplans.com/#form')}>SCHEDULE DEMO</Button>
          </div>
        </div>
      </div>
    </section>
    <section className={classNames(styles.blueBg, 'text-center p-5 d-flex align-items-center flex-column justify-content-center')}>
      <h2 className='text-white'>A better way to manage.</h2>
    </section>
  </div>